<app-page-shell [breadcrumb]="breadcrumb" width="wide">
  <header class="mx-auto max-w-4xl px-6 pt-12 pb-10 text-center md:pt-16">
    <p class="mb-4 eyebrow">{{ 'pages.regbr.hero.eyebrow' | transloco }}</p>
    <h1 class="hero-title font-display text-4xl font-bold leading-[1.06] text-foreground md:text-[3.25rem]">
      <span>{{ 'pages.regbr.hero.titlePrefix' | transloco }}</span>
      <span class="hero-title-accent italic font-medium text-primary">{{ 'pages.regbr.hero.titleAccent' | transloco }}</span>
    </h1>
    <p class="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-muted-foreground md:text-[17px]">
      {{ 'pages.regbr.hero.description' | transloco }}
    </p>
  </header>

  <div class="container mx-auto max-w-7xl px-6 pb-24">
    <app-regbr-tabs />

    <section class="mt-10 space-y-4 text-[15px] leading-relaxed text-muted-foreground">
      <p [innerHTML]="'pages.regbr.flow.update' | transloco"></p>
      <p>{{ 'pages.regbr.flow.description' | transloco }}</p>
    </section>

    <section class="mt-12">
      <p class="mb-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {{ 'pages.regbr.filters.groupBy' | transloco }}
      </p>
      <div
        role="tablist"
        class="inline-flex flex-wrap items-center gap-1 rounded-full border border-border bg-muted/50 p-1 text-sm"
      >
        @for (option of groupOptions; track option.value) {
          <button
            type="button"
            role="tab"
            (click)="setGroupBy(option.value)"
            [attr.aria-selected]="groupBy() === option.value"
            class="rounded-full px-4 py-1.5 font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
            [class.bg-primary]="groupBy() === option.value"
            [class.text-primary-foreground]="groupBy() === option.value"
            [class.shadow-sm]="groupBy() === option.value"
            [class.text-muted-foreground]="groupBy() !== option.value"
            [class.hover:text-foreground]="groupBy() !== option.value"
          >
            {{ option.labelKey | transloco }}
          </button>
        }
      </div>
    </section>

    <section class="mt-8 grid gap-6 lg:grid-cols-[280px_1fr]">
      <aside class="lg:sticky lg:top-24 lg:self-start">
        <div class="rounded-2xl border border-border bg-card/70 backdrop-blur-sm">
          <div class="flex items-center justify-between gap-2 border-b border-border px-4 py-3">
            <div class="flex items-center gap-2">
              <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="h-3.5 w-3.5 text-primary">
                <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
              </svg>
              <h2 class="text-xs font-semibold uppercase tracking-wider text-foreground">
                {{ 'pages.regbr.filters.title' | transloco }}
              </h2>
            </div>
            <button
              type="button"
              (click)="resetFilters()"
              class="text-[11px] font-medium text-muted-foreground transition hover:text-primary"
            >
              {{ 'pages.regbr.filters.reset' | transloco }}
            </button>
          </div>

          <div class="space-y-5 p-4">
            @if (groupBy() === 'agencia_reguladora') {
              <app-regbr-filter-list
                [label]="'pages.regbr.filters.agency' | transloco"
                [options]="agencyOptions"
                [values]="agencias()"
                (valuesChange)="setAgencias($event)"
              />
            } @else {
              <app-regbr-filter-list
                [label]="'pages.regbr.filters.sector' | transloco"
                [options]="sectorOptions"
                [values]="setores()"
                (valuesChange)="setSetores($event)"
              />
            }

            <app-regbr-filter-list
              [label]="'pages.regbr.filters.actType' | transloco"
              [options]="activeLawOptions()"
              [values]="tiposLei()"
              (valuesChange)="setTiposLei($event)"
            />

            <app-regbr-filter-list
              [label]="'pages.regbr.filters.status' | transloco"
              [options]="situationOptions"
              [values]="situacoes()"
              (valuesChange)="setSituacoes($event)"
            />
          </div>
        </div>
      </aside>

      <div class="min-w-0">
        @if (loadingChart()) {
          <div class="mt-8 h-[540px] animate-pulse rounded-3xl border border-border bg-muted/50"></div>
        } @else if (chartOptions()) {
          <app-chart-card
            [title]="'pages.regbr.flow.chartTitle' | transloco"
            [subtitle]="'pages.regbr.flow.chartSubtitle' | transloco"
            [chartOptions]="chartOptions()"
            [source]="'pages.regbr.source' | transloco"
            [updatedAt]="'pages.regbr.updatedAt' | transloco"
            exportFileName="regbr-fluxo-regulatorio"
            [chartHeight]="520"
          />
        } @else {
          <div class="mt-8 rounded-3xl border border-border bg-card p-10 text-center">
            <p class="font-display text-base font-semibold text-foreground">
              {{ 'pages.regbr.flow.emptyTitle' | transloco }}
            </p>
            <p class="mt-1 text-sm text-muted-foreground">
              {{ 'pages.regbr.flow.emptyDescription' | transloco }}
            </p>
          </div>
        }
      </div>
    </section>
  </div>
</app-page-shell>
